import { IStores } from "./index";
import * as services from "services";
import { ListStoreConstructor } from "./ListStoreConstructor";
import { UserCheckGridDto } from "interfaces";

export class AmlCheckList extends ListStoreConstructor<UserCheckGridDto> {
  constructor(stores: IStores) {
    super(
      stores,
      (params) => {
        return services.getUserWalletCheckList(params).then((response) => ({
          content: response.content || [],
          size: response.size || 0,
          totalPages: response.totalPages || 0,
          totalElements: response.totalElements || 0,
        }));
      },
      {
        sorters: {
          created: "desc",
        },
      }
    );
  }
}
